export const convertDate = (num) => {
    // Array of month abbreviations
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    // Create a new Date object using the timestamp (num)
    const date = new Date(num);
    
    // Construct and return the formatted date string
    return date.getDate() + " " + month[date.getMonth()] + " " + date.getFullYear();
};
